import { createFilterOptions } from '@mui/material'
import { Filter } from 'components/core/search-filter/filter'
import { UserOrigin } from 'pbts/c1/api/user/v1/user'
import React, { useCallback } from 'react'
import { useIntl } from 'react-intl'

const UserOriginFilterOptions = [UserOrigin.DIRECTORY, UserOrigin.LOCAL, UserOrigin.SYSTEM]
const OriginFilterOptions = createFilterOptions<UserOrigin>({})

type UserOriginFilterProps = {
    value?: Array<UserOrigin>
    onChange: (updated: { origins: Array<UserOrigin> }, shouldPropagate?: boolean) => void
}

export const UserOriginFilter = ({ value, onChange: _onChange }: UserOriginFilterProps): React.ReactElement => {
    const intl = useIntl()

    const renderLabel = useCallback(
        (option: UserOrigin): string =>
            ({
                [UserOrigin.DIRECTORY]: intl.formatMessage({ id: 'user_origin_directory', defaultMessage: 'Directory' }),
                [UserOrigin.LOCAL]: intl.formatMessage({ id: 'user_origin_local', defaultMessage: 'Local' }),
                [UserOrigin.SYSTEM]: intl.formatMessage({ id: 'user_origin_system', defaultMessage: 'System' }),
            }[option] ?? ''),
        [intl],
    )

    const onChange = useCallback(
        (origins: Array<UserOrigin>): void => _onChange({ origins }, true),
        [_onChange],
    )

    return (
        <Filter<UserOrigin>
            label={intl.formatMessage({
                id: 'user_filter_origin',
                defaultMessage: 'Origin',
            })}
            options={UserOriginFilterOptions}
            selected={value}
            onChange={onChange}
            filterOptions={OriginFilterOptions}
            renderLabel={renderLabel}
        />
    )
}
